const pillars = [
  {
    tag: "01 / Accommodation",
    title: "15 Quiet Guest Rooms",
    copy: "Spacious Standard, Comfort, and Family rooms tailored for both quick business stops and family holidays.",
    img: "https://images.unsplash.com/photo-1648132274182-1bd07089d2c9",
    alt: "Crisp white hotel bed linen close up",
    testId: "pillar-accommodation",
  },
  {
    tag: "02 / Gastronomy",
    title: "The Guesthouse Restaurant",
    copy: "Start each morning with fresh breakfasts and conclude the day with flavoursome meals in an easy setting.",
    img: "/images/restaurant.jpeg",
    alt: "Outdoor thatched dining area at Tse Yaa Kuku restaurant",
    testId: "pillar-restaurant",
  },
  {
    tag: "03 / Social Space",
    title: "Lounge Bar",
    copy: "An inviting bar worth lingering at to unwind with refreshing drinks, cool beer, and relaxed chatter.",
    img: "/images/bar-lounge.jpeg",
    alt: "Wooden lounge bar interior at Tse Yaa Kuku with bar counter seating",
    testId: "pillar-bar",
  },
];

export const Overview = () => (
  <section id="overview" data-testid="overview-section" className="py-24 px-8 max-w-7xl mx-auto">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
      {pillars.map((p) => (
        <div key={p.testId} data-testid={p.testId} className="space-y-4">
          <div className="aspect-video w-full rounded-2xl overflow-hidden border border-[#E3DFD5] relative bg-[#EBE7DD]">
            <img
              src={p.img}
              alt={p.alt}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <span className="font-mono-tag text-xs tracking-widest text-[#9E7D4E] uppercase">
            {p.tag}
          </span>
          <h3 className="font-editorial text-2xl text-[#1A1A18]">{p.title}</h3>
          <p className="font-grotesk text-sm text-[#55524A] leading-relaxed">{p.copy}</p>
        </div>
      ))}
    </div>
  </section>
);
